// Use the Orders portal's existing address vocabulary on cold entry: its mount
// restores URL/remembered world and would otherwise replace the requested store.
// The Collection world is the exception to "default view = overview": its plain Wall is the
// ABSENT `view` (overview there is the "Coming soon" placeholder), and its line rides as &book=optic.
const COLLECTION_PARAMS = ['view','id','line','comment','model','q','status','group','sort','density','rq','rstatus','rsort','rdir','rdensity','xb','xq','kind','supplier','sheet','fam','mat','sub','nyo','year'];
export function prepareHomeOrdersAddress(target, browser = window) {
  const url = new URL(browser.location.href);
  url.searchParams.set('tab','orders');
  url.searchParams.set('world',target.world);
  if (target.world === 'collection') {
    COLLECTION_PARAMS.forEach(key => url.searchParams.delete(key));
    if (target.collectionLine === 'optic') url.searchParams.set('book','optic');
    else if (target.collectionLine) url.searchParams.delete('book');
  } else {
    url.searchParams.set('view',target.world === 'desk' ? target.deskView : ({summary:'overview',data:'table'}[target.ordersView] || target.ordersView || 'overview'));
    ['id','line','comment'].forEach(key => url.searchParams.delete(key));
  }
  browser.history.replaceState({},'',url.toString());
}
